
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./web-panel.cjs.production.min.js')
} else {
  module.exports = require('./web-panel.cjs.development.js')
}
